module.exports = __webpack_public_path__ + "img/hardware.48104052.jpg";